import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PubMainTypeEnum, PubSuffixTypeEnum } from '../../../types';
/** this function return intial tab index based on the intial form state */

var getInitialTabIndex = function getInitialTabIndex(pubtype) {
  if (pubtype && pubtype.suffix == PubSuffixTypeEnum.PUB_NONE) {
    switch (pubtype.main) {
      case PubMainTypeEnum.PUB_ONLINE:
        return 1;
      case PubMainTypeEnum.PUB_MAGAZINE:
        return 2;
      case PubMainTypeEnum.PUB_NEWSPAPER:
        return 3;
      default:
        return 0;
    }
  }
  return 0;
};
var getPubTypeMainEnumFromTabIndex = function getPubTypeMainEnumFromTabIndex(index) {
  switch (index) {
    case 1:
      return PubMainTypeEnum.PUB_ONLINE;
    case 2:
      return PubMainTypeEnum.PUB_MAGAZINE;
    case 3:
      return PubMainTypeEnum.PUB_NEWSPAPER;
    default:
      return PubMainTypeEnum.PUB_NONPERIODICAL;
  }
};
var useCartoonTabs = function useCartoonTabs(_ref) {
  var intialPubtypeState = _ref.intialPubtypeState;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var initialActiveIndex = getInitialTabIndex(intialPubtypeState);
  var _useState = useState(initialActiveIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabIndex = _useState2[0],
    setActiveTabIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    preservedPubtypeStateForTabs = _useState4[0],
    setPreservedPubtypeStateForTabs = _useState4[1];

  /** This will initialize the pubtype state, if not already present */
  useEffect(function () {
    if (!intialPubtypeState) {
      setFieldValue('pubtype', {
        main: getPubTypeMainEnumFromTabIndex(0),
        suffix: PubSuffixTypeEnum.PUB_NONE
      });
    }
    setPreservedPubtypeStateForTabs([]);
    setActiveTabIndex(getInitialTabIndex(intialPubtypeState));
  }, [intialPubtypeState, setFieldValue]);
  var handleTabChange = function handleTabChange(newActiveTabIndex) {
    /** copying prev state, before any change happens */
    var prevActiveIndex = activeTabIndex;
    var prevSuffixPubTypeValue = values.pubtype.suffix;
    var prevMainPubTypeValue = values.pubtype.main;
    setActiveTabIndex(newActiveTabIndex);
    /** updating formik state with preserved/default value for that tab-index */

    var preservedStatusFornewActiveTabIndex = preservedPubtypeStateForTabs[newActiveTabIndex] || null;
    setFieldValue('pubtype', // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    preservedStatusFornewActiveTabIndex !== null && preservedStatusFornewActiveTabIndex !== void 0 ? preservedStatusFornewActiveTabIndex : {
      main: getPubTypeMainEnumFromTabIndex(newActiveTabIndex),
      suffix: PubSuffixTypeEnum.PUB_NONE
    });

    /** preserving prev state */
    setPreservedPubtypeStateForTabs(function (state) {
      state[prevActiveIndex] = {
        main: prevMainPubTypeValue,
        suffix: prevSuffixPubTypeValue
      };
      return state;
    });
  };
  return {
    activeTabIndex: activeTabIndex,
    handleTabChange: handleTabChange
  };
};
export default useCartoonTabs;